import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import { Trans } from "../../utils/i18n";
import Markdown from "react-markdown";

export function SelfRepairFlowMetaData({
    targetUser,
    estimatedTime,
    complexity,
}) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 divide-y md:divide-y-0 md:divide-x divide-gray-200 border border-gray-200 rounded-md">
            {[
                {
                    title: <Trans i18nKey="orderEntry.selfFix.targetUser" />,
                    content: (
                        <Markdown className="[&>ul]:p-0 [&>ul]:space-y-2 [&>ul]:list-none [&>ul]:m-0 [&>p]:m-0">
                            {targetUser}
                        </Markdown>
                    ),
                    icon: <GroupsOutlinedIcon className="text-white" />,
                },
                {
                    title: <Trans i18nKey="orderEntry.selfFix.time" />,
                    content: (
                        <Markdown className="[&>ul]:p-0 [&>ul]:space-y-2 [&>ul]:list-none [&>ul]:m-0 [&>p]:m-0">
                            {estimatedTime}
                        </Markdown>
                    ),
                    icon: <AccessTimeOutlinedIcon className="text-white" />,
                },
                {
                    title: <Trans i18nKey="orderEntry.selfFix.complexity" />,
                    content: (
                        <div>
                            {complexity === "low" ? (
                                <Trans i18nKey="selfRepair.complexity.low">
                                    Low
                                </Trans>
                            ) : complexity === "medium" ? (
                                <Trans i18nKey="selfRepair.complexity.medium">
                                    Medium
                                </Trans>
                            ) : complexity === "high" ? (
                                <Trans i18nKey="selfRepair.complexity.high">
                                    High
                                </Trans>
                            ) : null}
                        </div>
                    ),
                    icon: <SpeedOutlinedIcon className="text-white" />,
                },
            ].map((item) => (
                <div className="flex flex-col items-center text-center p-4 gap-4">
                    <div className="flex flex-col items-center gap-4">
                        <div className="flex justify-center items-center p-2 rounded bg-secondary">
                            {item.icon}
                        </div>
                        <div className="font-bold">{item.title}</div>
                    </div>
                    <div className="flex-1">{item.content}</div>
                </div>
            ))}
        </div>
    );
}
